import type { FeatureIconsProps } from '@/pages/solutions/[type]/new-items/feature-icons'
import type { ImageTextItemProps } from '@/pages/solutions/[type]/new-items/image-text'
import { IconName } from '@/components/icon'

import banner from '@/assets/img/solution/green-city/banner.jpg'

import featureBanner1 from '@/assets/img/solution/green-city/featureBanner_1.jpg'
import imageText_1_1 from '@/assets/img/solution/green-city/image_text_1_1.jpg'
import imageText_1_2 from '@/assets/img/solution/green-city/image_text_1_2.jpg'
import imageText_1_3 from '@/assets/img/solution/green-city/image_text_1_3.jpg'
import application_1_2 from '@/assets/img/solution/green-city/application_1_2.jpg'
import application_1_1 from '@/assets/img/solution/green-city/application_1_1.jpg'
import application_1_3 from '@/assets/img/solution/green-city/application_1_3.jpg'
import application_1_4 from '@/assets/img/solution/green-city/application_1_4.jpg'
import application_1_5 from '@/assets/img/solution/green-city/application_1_5.jpg'

import featureBanner2 from '@/assets/img/solution/green-city/featureBanner_2.jpg'
import application_2_1 from '@/assets/img/solution/green-city/application_2_1.jpg'
import application_2_2 from '@/assets/img/solution/green-city/application_2_2.jpg'
import application_2_3 from '@/assets/img/solution/green-city/application_2_3.jpg'
import application_2_4 from '@/assets/img/solution/green-city/application_2_4.jpg'
import application_2_5 from '@/assets/img/solution/green-city/application_2_5.jpg'

import subBanner3 from '@/assets/img/solution/green-city/subBanner_3.jpg'
import imageText_3_1 from '@/assets/img/solution/green-city/image_text_3_1.jpg'
import imageText_3_2 from '@/assets/img/solution/green-city/image_text_3_2.jpg'
import imageText_3_3 from '@/assets/img/solution/green-city/image_text_3_3.jpg'
import application_3_1 from '@/assets/img/solution/green-city/application_3_1.jpg'
import application_3_2 from '@/assets/img/solution/green-city/application_3_2.jpg'
import application_3_3 from '@/assets/img/solution/green-city/application_3_3.jpg'

import featureBanner4 from '@/assets/img/solution/green-city/featureBanner_4.jpg'
import application_4_1 from '@/assets/img/solution/green-city/application_4_1.jpg'
import application_4_2 from '@/assets/img/solution/green-city/application_4_2.jpg'
import application_4_3 from '@/assets/img/solution/green-city/application_4_3.jpg'
import application_4_4 from '@/assets/img/solution/green-city/application_4_4.jpg'
import application_4_5 from '@/assets/img/solution/green-city/application_4_5.jpg'
import footerBanner_5 from '@/assets/img/solution/medical/footer-banner.jpg'

import subBanner5 from '@/assets/img/solution/green-city/subBanner_5.jpg'
import imageText_5_1 from '@/assets/img/solution/green-city/image_text_5_1.jpg'
import imageText_5_2 from '@/assets/img/solution/green-city/image_text_5_2.jpg'
import imageText_5_3 from '@/assets/img/solution/green-city/image_text_5_3.jpg'
import imageText_5_4 from '@/assets/img/solution/green-city/image_text_5_4.jpg'
import imageText_6_1 from '@/assets/img/solution/green-city/image_text_6_1.jpg'
import imageText_6_2 from '@/assets/img/solution/green-city/image_text_6_2.jpg'
import imageText_6_3 from '@/assets/img/solution/green-city/image_text_6_3.jpg'
import imageText_6_4 from '@/assets/img/solution/green-city/image_text_6_4.jpg'
import application_6_1 from '@/assets/img/solution/green-city/application_6_1.jpg'
import application_6_2 from '@/assets/img/solution/green-city/application_6_2.jpg'
import application_6_3 from '@/assets/img/solution/green-city/application_6_3.jpg'
import application_6_4 from '@/assets/img/solution/green-city/application_6_4.jpg'

import { solution_medical } from './medical'
import type { SolutionMedicalProps } from '../type'

export interface SubSolutionProps {
  icon: IconName
  iconLabel: string
  subBanner?: string
  featureBanner?: string
  title?: string
  featureInfo?: {
    title?: string
    items?: string[]
  }
  featureIcons?: FeatureIconsProps[]
  imageText?: ImageTextItemProps[]
  advantages?: SolutionMedicalProps['advantages']
  footer?: {
    banner: string
  }
  applications?: {
    title: string
    description?: string | string[]
    image: string
  }[]
}

export interface SolutionGreenCityProps {
  id: number
  title: string
  description: string
  path: string
  banner: string
  children: SubSolutionProps[]
}

export const solution_green_city: SolutionGreenCityProps = {
  id: 2,
  path: '/solution/green-city',
  banner: banner,
  title: 'Green City Solution',
  description:
    'We provide energy solutions like solar PV, BESS, and EV charging from design to commissioning. Our expertise includes modeling, hardware integration, and energy management.',
  children: [
    // 1、分布式光伏和储能（C&I & Residential）
    {
      icon: 'battery',
      iconLabel: 'C&I',
      title: 'Distributed PV and ESS (C&I & Residential)',
      featureBanner: featureBanner1,
      featureInfo: {
        title:
          'Ubiquitous photovoltaic systems produce more green electricity, and energy storage systems maximize the value of green electricity. This allows more participants to enjoy the benefits of green energy, collectively reduce carbon emissions, and create a green city.',
      },
      imageText: [
        {
          content: [
            {
              image: imageText_1_1,
              title: 'VPP (A virtual power plant)',
              descriptions: [
                'We aggregates distributed energy resources through advanced information and communication technology (ICT) and energy management systems (EMS), forming a unified and flexibly dispatchable power supply system.Optimizing Energy Resource Allocation & Reducing Electricity CostsEnhancing Grid Stability & Power Supply ReliabilityIncreasing Renewable Energy Utilization & Promoting Energy Transition',
              ],
            },
            {
              image: imageText_1_2,
              title: 'DSGS (Demand Side Grid Support)',
              descriptions: [
                'The DSGS Program provides incentives to reduce customer net load during extreme events with upfront capacity commitments and for per-unit reductions in net load.1. Demand-side management technologies reduce grid pressure and improve energy efficiency.2. Investors further gain subsidy benefits from DSGS.',
              ],
            },
          ],
        },
        {
          title: ' More Application Scenarios',
          content: [
            {
              image: imageText_1_3,
              title: 'Carus Mobile Power',
              descriptions: [
                'The mobile power incorporates the design concept of an online UPS to achieve seamless switching between mains power and the energy storage power source. This ensures emergency power supply and uninterrupted power for critical loads.',
              ],
            },
          ],
        },
        {
          title: 'Advantages',
          content: [
            {
              descriptions: [
                'In Florida, high winds during hurricanes can lift off traditional rooftop solar panels. Our integrated solar roof tiles, installed flush with the roof, create a negative pressure effect that significantly boosts wind resistance. Tested to withstand gusts up to 107 mph, they ensure reliable energy generation and enhanced structural protection.',
              ],
            },
          ],
          featureIcons: [
            {
              icon: 'energyManage',
              label: 'Economic Benefits',
            },
            {
              icon: 'economic',
              label: 'Energy Resilience',
            },
            {
              icon: 'greenEnergy',
              label: 'Sustainability',
            },
            {
              icon: 'energyIndependence',
              label: 'Smart Energy Management',
            },
            {
              icon: 'greenEarth',
              label: 'Future-Proofing',
            },
          ],
        },
      ],
      applications: [
        {
          title: 'Industrial Parks and Factories',
          image: application_1_1,
        },
        {
          title: 'Commercial Buildings',
          image: application_1_2,
        },
        {
          title: 'Daily Household Electricity Use',
          image: application_1_3,
        },
        {
          title: 'Emergency Backup Power',
          image: application_1_4,
        },
        {
          title: 'Microgrids for Remote Facilities',
          image: application_1_5,
        },
      ],
    },
    // 2、智能储能充电站
    {
      icon: 'charge',
      iconLabel: 'Smart BESS Charging',
      title: 'Carus PV street lighting system',
      featureBanner: featureBanner2,
      featureInfo: {
        title:
          'The Smart BESS Charging Station combines three functions: PV, energy storageservice, electric vehicle charging service, controlled and managed by the energymanagement system. Addressing the Growing Charging Demand for Electric Vehicles.',
      },
      featureIcons: [
        {
          icon: 'greenEnergy',
          label: 'Integrated Management System',
        },
        {
          icon: 'greenBattery',
          label: 'Standard Connector Interface',
        },
        {
          icon: 'sustainabilityPro',
          label: 'Provide Backup Power',
        },
      ],
      applications: [
        {
          title: 'Industrial Parks and Factories',
          description:
            'Powers manufacturing processes, machinery, and lighting while providing backup power for critical operations.',
          image: application_2_1,
        },
        {
          title: 'Commercial Buildings',
          description:
            'Supplies energy for lighting, HVAC systems, elevators, and security systems in offices, shopping malls, and supermarkets.',
          image: application_2_2,
        },
        {
          title: 'Warehouses and Logistics Centers',
          description:
            'Supports refrigeration, lighting, and electric forklifts, while offering EV charging for delivery vehicles.',
          image: application_2_3,
        },
        {
          title: 'Electric Vehicle Charging Hubs',
          description: 'Provides daily charging services for EVs and ensures backup power for charging stations.',
          image: application_2_4,
        },
        {
          title: 'Microgrids for Remote Facilities',
          description:
            'Establishes independent power systems for hotels, resorts, mines, or medical facilities in remote or off-grid areas.',
          image: application_2_5,
        },
      ],
    },
    // 3、物流园区
    {
      icon: 'logistics',
      iconLabel: 'Logistics EV',
      subBanner: subBanner3,
      imageText: [
        {
          title: 'Our Solution',
          cards: [
            {
              title: 'Solar System',
              description:
                'Install solar PV systems on warehouse rooftops and parking lots, generating annual electricity to cover 25%-50% of energy demand.',
            },
            {
              title: 'Energy Storage Systems',
              description: 'Deploy grid-tied energy storage systems with a capacity range of 2 MWh to 5 MWh',
            },
            {
              title: 'Charging Infrastructure',
              description:
                'Dynamically adjust the number of fast-charging stations based on the size of the logistics fleet.',
            },
          ],
        },
        {
          content: [
            {
              image: imageText_3_1,
              title: 'Solar System + Energy Storage + Charging Station',
              noDotIndex: [0, 1, 2, 3],
              descriptions: [
                'Solution Components:',
                '1. Solar PV: 100-150kw',
                '2. Energy Storage: 3 units of ESS in 232kwh (along with 3units of PCS in 125kw)',
                '3. Charger: 3 units of 120Kw DC Integrated EV Charger',
                'Amount of electricity need (6 Light-duty commercial EV):140*6*80%=672kwh',
                'Daily Energy output: 500~750kwh (based on 5 hours/day average solar generation in South California)',
                'With installation of Solar PV, customers can cover most of it’s  energy need by using green energy produced by their ownequipment.',
              ],
            },
            {
              image: imageText_3_2,
              title: 'Solar System + Energy Storage + Charging Station',
              descriptions: [
                'Power Conversion System (PCS): 125 kW × 3 units (total 375 kW)',
                'Storage Capacity: 232–326 kWh × 3 units (total 696 kWh).',
                'Chargers: 3 units, 120 kW each.',
                'Charging Ports: 2 ports per charger (total 6 ports).',
              ],
            },
            {
              image: imageText_3_3,
              title: 'Mobile Power only',
              descriptions: [
                '20 ft Container: Portable ESS with 1.6 MWh - 3.3 MWh, fast-charging for EV fleets.',
                'Mini Container: Compact 1.5MWh solution with dual 240 kW chargers.',
                'Mobile Cabinet Power: Flexible 250 kW - 750 kW units for off-grid applications.',
              ],
            },
          ],
        },
      ],
      applications: [
        {
          title: 'Power Source for Mobile PowerRemote',
          description:
            'energy replenishment is also included in our services. Even if you cannot install our solar    system, you can still benefit from the low-costenergy provided by our solar power stationsstations',
          image: application_3_1,
        },
        {
          title: 'Power Source for Mobile Power',
          description:
            'Remote energy replenishment is also included in our services. Even if you cannot install our solar system, you can still benefit from the low-cost energy provided by our solar power stations',
          image: application_3_2,
        },
        {
          title: 'Heavy-duty trucks',
          description: 'With a fleet of size between 5 to 6 trucks',
          image: application_3_3,
        },
      ],
    },
    // 4、智慧路灯
    {
      icon: 'streetLamp',
      iconLabel: 'Public Lighting Upgrade',
      title: 'Carus PV street lighting system',
      featureBanner: featureBanner4,
      featureInfo: {
        title: 'Integrates a high-security smart LFP (Lithium lronPhosphate)energy storage system',
        items: [
          'Maximizing the use of solar power generation',
          'When solar power is insufficient, prioritizing charging from the grid during off-peak hours at lower rates.',
        ],
      },
      featureIcons: [
        {
          icon: 'increase',
          label: 'Smart Lighting Control',
        },
        {
          icon: 'energyIndependence',
          label: 'Lower Carbon Emissions',
        },
        {
          icon: 'greenEarth',
          label: 'Best-in-class LightingPerformance',
        },
        {
          icon: 'energyManage',
          label: 'Less Maintenance',
        },
        {
          icon: 'sustainabilityPro',
          label: 'Long Working Time',
        },
        {
          icon: 'hightStability',
          label: 'High Stability-1P66/K08',
        },
      ],
      applications: [
        {
          title: 'Roads ,Bicycle lanes and Pathways',
          description: '',
          image: application_4_1,
        },
        {
          title: 'Parks, Rural areas,Residential areas',
          description: '',
          image: application_4_2,
        },
        {
          title: 'Commercial. Industrial,School campuses',
          description: '',
          image: application_4_3,
        },
        {
          title: 'Remote off-grid locations, including coastal regions and islands',
          description: '',
          image: application_4_4,
        },
        {
          title: 'Infrastructure Repair and Recovery',
          description: 'Assists in powering construction equipment and tools for rebuilding damaged infrastructure.',
          image: application_4_5,
        },
      ],
    },
    // 5、公交充电站
    {
      icon: 'schoolBus',
      iconLabel: 'School Bus',
      subBanner: subBanner5,
      imageText: [
        {
          title: 'Charging Infrastructure Solution',
          content: [
            {
              image: imageText_5_1,
              title: 'Direct Charging Stations',
              descriptions: ['Suitable for locations with sufficient grid capacity.'],
            },
            {
              image: imageText_5_2,
              title: 'Energy Storage + Charging Stations',
              descriptions: [
                'Ideal for areas with limited grid capacity or future expansion challenges.',
                'Optional Integration: provide additional power with PV system, further reduce grid dependency.',
              ],
            },
            {
              image: imageText_5_3,
              title: 'Mobile Power Unit + Fixed Charging Stations',
              descriptions: [
                'Combines flexibility of mobile ESS with fixed stations.',
                'Scalable Design: Supports varying fleet sizes operational needs.',
              ],
            },
            {
              image: imageText_5_4,
              title: 'Mobile ESS Charging Stations + Green Power Supplement',
              descriptions: [
                'Chargers: Two 120 kW dual-gun chargers; full charge in 3–4 hours per bus.',
                'Night Charging: Low-power battery replenishment to save costs.',
                'Solar Integration: Install a 120 kW solar PV system for added energy & sustainability.',
              ],
            },
          ],
        },
      ],
      advantages: solution_medical.advantages,
      footer: {
        banner: footerBanner_5,
      },
    },
    // 6、太阳能屋顶
    {
      icon: 'disaster',
      iconLabel: 'Disaster Relief',
      imageText: [
        {
          title: 'Solar Tile Solutions for Florida Extreme Weather',
          subTitle:
            'In Florida, high winds during hurricanes can lift off traditional rooftop solar panels. Our integrated solar roof tiles, installed flush with the roof, create a negative pressure effect that significantly boosts wind resistance. Tested to withstand gusts up to 107 mph, they ensure reliable energy generation and enhanced structural protection.',
          content: [
            {
              image: imageText_6_1,
              imageWidth: '90%',
            },
          ],
          featureIcons: [
            {
              icon: 'increase',
              label: ' Extreme Winds & Hurricane Impacts',
            },
            {
              icon: 'greenBattery',
              label: 'Prolonged Heavy Rain & Flooding Risks',
            },
            {
              icon: 'greenEarth',
              label: 'Structural Stability Under Heavy Loads',
            },
            {
              icon: 'internet',
              label: 'High Conversion Efficiency & Aesthetic Integration',
            },
          ],
        },
        {
          title: 'Energy Storage System Solution',
          flag: 'Solution',
          content: [
            {
              image: imageText_6_2,
              title: 'Utility-Scale ESS',
              tag: [
                'Regional Grid Resilience And Security',
                'Transmission And Distribution Deferral',
                'Grid Frequency Regulation And Stability',
              ],
              descriptions: [
                'Carus utility-scale energy storage system integrates a high energy density and high-efficiency liquid-cooling battery system, equipped with cabinet-level fire protection, system-level fire protection, and grid-connected transformers. This robust design ensures energy security and reliable regional power supply, empowering grid operators to effectively manage energy fluctuations, support peak shaving, and seamlessly integrate large-scale intermittent renewable energy sources.',
              ],
            },
            {
              image: imageText_6_3,
              title: 'C&I Energy Storage System',
              tag: ['Clinics & Surgery Centers', 'Commercial Properties', 'Factory/Data Center'],
              descriptions: [
                'Commercial and industrial energy storage solutions integrate battery systems, energy management systems, energy storage inverters, and intelligent temperature control systems into one solution. The system can operate without an external power supply. It is suitable for various application scenarios such as peak shaving and valley filling, high-power grid expansion, factory backup power, data center power protection, emergency power supply, and charging station expansion.',
              ],
            },
            {
              image: imageText_6_4,
              title: 'Residential ESS',
              tag: ['Resident & Small Business', 'Energy Independence', 'Cost Savings'],
              descriptions: [
                'Residential energy storage system delivers stackable, modular battery units paired with hybrid inverters for seamless home energy management. Featuring advanced liquid cooling and multi-level safety protection, it maximizes solar consumption, provides backup power, and adapts to evolving household energy needs. Empowers homeowners to achieve energy independence and ensure energy safety.',
              ],
            },
          ],
        },
        {
          title: 'Mobile Power Solution',
          content: [
            {
              descriptions: [
                'In Florida, high winds during hurricanes can lift off traditional rooftop solar panels. Our integrated solar roof tiles, installed flush with the roof, create a negative pressure effect that significantly boosts wind resistance. Tested to withstand gusts up to 107 mph, they ensure reliable energy generation and enhanced structural protection.',
              ],
            },
          ],
        },
      ],
      applications: [
        {
          title: 'Temporary power supply',
          description: 'Construction Site,Outdoor Work,Emergency Communication Network',
          image: application_6_1,
        },
        {
          title: 'Emergency power supply',
          description: 'Post-disaster Relief And Construction,Power Maintenance',
          image: application_6_2,
        },
        {
          title: 'Communities & Households',
          description: 'Emergency Charging,Temporary Independent Power',
          image: application_6_3,
        },
        {
          title: 'Backup power',
          description: 'Clinics & Surgery Centers,Commercial Properties,Factory/Data center',
          image: application_6_4,
        },
      ],
    },
  ],
}
